import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { settingsAPI } from '../lib/api';
import { initFbPixel, fbPageView } from '../lib/fbPixel';

// Loads Meta Pixel (ID from CMS settings) and tracks SPA page views
export const FacebookPixel = () => {
  const location = useLocation();
  const initializedRef = useRef(false);
  const firstPathRef = useRef(true);

  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;
    settingsAPI.get().then(res => {
      if (res.data?.fb_pixel_id) initFbPixel(res.data.fb_pixel_id.trim());
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (firstPathRef.current) { firstPathRef.current = false; return; }
    fbPageView();
  }, [location.pathname]);

  return null;
};
